/**
 * Zero padding strategy.
 */
export var ZeroPadding = {
  pad: function pad(data, blockSize) {
    var _data = data; // Shortcut

    var blockSizeBytes = blockSize * 4; // Pad

    _data.clamp();

    _data.sigBytes += blockSizeBytes - (data.sigBytes % blockSizeBytes || blockSizeBytes);
  },
  unpad: function unpad(data) {
    var _data = data; // Shortcut

    var dataWords = _data.words; // Unpad

    for (var i = _data.sigBytes - 1; i >= 0; i -= 1) {
      if (dataWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff) {
        _data.sigBytes = i + 1;
        break;
      }
    }
  }
};